
import {
  IonPage,
  IonContent,
  IonInfiniteScrollContent,
  IonInfiniteScroll,
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonItemGroup,
  IonSelect,
  IonSelectOption,
  IonIcon,
  IonLabel,
  IonChip,
} from "@ionic/vue";
import { closeCircle } from "ionicons/icons";
import NetworkError from "@/components/NetworkError.vue";
import EstablishmentCard from "@/components/cards/EstablishmentCard.vue";
import EstablishmentCardSkeleton from "@/components/skeletonComponents/EstablishmentCardSkeleton.vue";

import SortByGet from "@/data/providers/sort-by";

import { Ref, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import searchPost from "@/data/providers/search/search-post";
import typesModule from "@/data/modules/typesModule";
import { slugify } from "@/utils/functions/string";

import HeaderWithBalance from "@/components/headers/HeaderWithBalance.vue";

export default {
  name: "SimpleSearch",
  ionViewWillEnter() {
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "Entregamos tudo o que você precisa com dinheiro de volta (cashback). São milhares de opções de delivery: do pãozinho ao sushi e do sabonete a remédios."
      );

    if (
      Object.keys(this.$route.params).length > 0 ||
      !this.establishmentsRef?.length
    ) {
      this.getEstablishments();
    }
  },
  components: {
    IonPage,
    IonContent,
    HeaderWithBalance,
    EstablishmentCard,
    EstablishmentCardSkeleton,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonItemGroup,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonLabel,
    IonChip,
    NetworkError,
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    const establishmentsRef: Ref = ref([]);
    const loadingRef = ref(true);
    const occurredErrorRef = ref(false);
    const cursorRef = ref(2);

    const sortBy = [...SortByGet];

    const search = store.state.search;

    let filtersValue;
    let idCategories;
    let payments;

    const getEstablishments = async () => {
      try {
        loadingRef.value = true;
        idCategories = store.state.search.categories.map(
          (category) => category.id
        );

        if (store.state.search.searchFilters) {
          filtersValue = store.state.search.searchFilters.map(
            (filters) => filters.value
          );
        }

        if (store.state.search.payments) {
          payments = store.state.search.payments.map((payments) => payments.id);
        }

        const establishmentsData = await searchPost({
          neighborhoodId: store.state.neighborhood.id,
          sortBy: store.state.search.searchSortBy.value,
          searchValue: store.state.search.searchName,
          filters: filtersValue,
          payments: payments,
          categories: idCategories,
        });

        establishmentsRef.value = establishmentsData;
        occurredErrorRef.value = false;
        cursorRef.value = 2;
      } catch (_error) {
        occurredErrorRef.value = true;
      } finally {
        loadingRef.value = false;
      }
    };

    const getNextEstablishments = async (event: any) => {
      try {
        idCategories = store.state.search.categories.map(
          (category) => category.id
        );

        if (store.state.search.searchFilters) {
          filtersValue = store.state.search.searchFilters.map(
            (filters) => filters.value
          );
        }

        if (store.state.search.payments) {
          payments = store.state.search.payments.map((payments) => payments.id);
        }
        const newEstablishments = await searchPost({
          neighborhoodId: store.state.neighborhood.id,
          sortBy: store.state.search.searchSortBy.value,
          searchValue: store.state.search.searchName,
          filters: filtersValue,
          payments: payments,
          categories: idCategories,
          page: cursorRef.value,
        });

        establishmentsRef.value.push(...newEstablishments);

        cursorRef.value = cursorRef.value + 1;
      } finally {
        event.target.complete();
      }
    };

    const goToEstablishment = (slug, categorySlug) => {
      const citySlug = store.state.neighborhood.citySlug;

      router.push(`/loja/${citySlug || "categoria"}/${categorySlug}/${slug}`);
    };

    const removeFilterPayment = (payment) => {
      store.dispatch(typesModule.actions.DELETE_CLEAR_PAYMENTS, payment);
      getEstablishments();
    };

    const removeFilterFilters = (filters) => {
      store.dispatch(typesModule.actions.DELETE_CLEAR_FILTERS, filters);
      getEstablishments();
    };

    const removeFilterCategories = (categories) => {
      store.dispatch(typesModule.actions.DELETE_CLEAR_CATEGORIES, categories);
      getEstablishments();
    };

    return {
      store,
      sortBy,
      search,
      loadingRef,
      establishmentsRef,
      cursorRef,
      goToEstablishment,
      getNextEstablishments,
      getEstablishments,
      removeFilterPayment,
      removeFilterFilters,
      removeFilterCategories,
      closeCircle,
      occurredErrorRef,
      slugify,
    };
  },
  data: function () {
    return {
      searchValueName: "",
      valueSortBy: {},
    };
  },

  watch: {
    valueSortBy: function () {
      this.store.dispatch(typesModule.actions.SET_SORT_BY, this.valueSortBy);
      this.getEstablishments();
    },
  },
};
